import { P } from "@vidstack/react/types/vidstack.js";

export const URL_PARAMS = {
  H_PARAM: "4l3jlj4141ljk",
};

export const questions = [
  {
    type: "question",
    badge: "1 - Minute Personal Assessment",
    question: "If I could, I’d want to...",
    answers: [
      "Make money from anywhere in the world",
      "Make some extra cash on the side",
      "Find a better job than the one I have now",
    ],
  },
  {
    type: "question",
    question: "I really want to reach <\n> this goal because...",
    answers: [
      "I want to quit my 9 to 5 job for something that makes me happier",
      "I want to step up and support my family",
      "I want to have more freedom in my life",
    ],
  },
  {
    type: "question",
    question: "What best describes your situation?",
    answers: [
      "I have a 9-5 job",
      "I have a 9-5 job, and a side hustle",
      "I'm a student trying to find ways to earn money",
    ],
  },
  {
    type: "question",
    question: "How often do you watch YouTube?",
    answers: [
      "Only when I’m bored",
      "Every single day",
      "Occasionally, about once a month",
    ],
  },
  {
    type: "question",
    question: "What topic are you interested in the most?",
    answers: [
      "Technology",
      "Sports",
      "Health",
      "Love",
      "Business",
      "History",
      "Entertainment",
      "Music",
    ],
  },
  {
    type: "fact",
    title: "Did you know ?",
    content:
      "A new interview with YouTube’s CEO revealed the << ‘’YouTube Creator Fund’’ >> has been paying creators over $63 million daily for the last three years.",
    image: "/images/image-1.webp",
    subcontent:
      "YouTube CEO << Neal Mohan >> revealed the company is focusing on AI and subscriptions, among other things, in 2024, which will ultimately increase the potential earnings of all YouTube partners",
  },
  {
    type: "question",
    question: "Have you ever made YouTube video?",
    answers: ["Yes", "No, I don’t know how", "No, I didn’t need to"],
  },
  {
    type: "question",
    question:
      "What's stopping you from starting your own profitable faceless channel?",
    answers: [
      "I don't know how it works",
      "I don't know how to do it",
      "I'm not sure why should I do that",
    ],
  },
  {
    type: "fact",
    title: "Fun Fact...",
    content:
      "YouTube creator ecosystem supports more than << 390,000 full-time equivalent jobs >> according to Forbes!",
    image: "/images/image-2.webp",
  },
  {
    type: "question",
    question:
      "Are you willing to dedicate 3-5 hours a week if it helps you achieve your goal?",
    answers: [
      "Yes, I'm committed to reaching my goal!",
      "Maybe if you can show me how to do it",
      "No",
    ],
  },
  {
    type: "question",
    badge: "Almost there...",
    question:
      "What's the biggest change <\n> you want to make in your life right now?",
    answers: [
      "I want more free time",
      "I want to quit my job and earn more",
      "I want to stop working for someone else",
      "I want to travel and work from anywhere in the world",
    ],
  },
  {
    type: "question",
    badge: "Last question...",
    question:
      "If you could have one thing, what would help you achieve your goal?",
    answers: [
      "A step-by-step plan on how to do it",
      "Having someone experienced guide me",
      "A proven system that already works",
    ],
  },
];

export const icons = ["📱", "⚽", "🏥", "💖", "💼", "📜", "🎬", "🎹"];

export const membershipCourse = {
  blueprint: "course=7FigureBlueprint",
  launchpad: "course=7FigureLaunchpad",
  endlessIdea: "course=EndlessIdea",
} as const;

export const avatars = [
  {
    src: "/images/avatar-1.webp",
    alt: "Avatar 1",
  },
  {
    src: "/images/avatar-2.webp",
    alt: "Avatar 2",
  },
  {
    src: "/images/avatar-3.webp",
    alt: "Avatar 3",
  },
  {
    src: "/images/avatar-4.webp",
    alt: "Avatar 4",
  },
  {
    src: "/images/avatar-5.webp",
    alt: "Avatar 5",
  },
  {
    src: "/images/avatar-6.webp",
    alt: "Avatar 6",
  },
  {
    src: "/images/avatar-7.webp",
    alt: "Avatar 7",
  },
];

export const ROUTES = {
  LOGIN: "/login",
  QUIZ: "/quiz",
  OPTIN: "/results",
  SALES: "/your-results",
  PASSION: "/passion",
  FIVE_DAYS: "/5days",
  YT_PASSION: "/yt-passion",
  ACCESS: "/access",
  CHECKOUT: "/checkout",
  CHECKOUT2: "/checkout-2",
  UPSELL1: "/oto1",
  UPSELL2: "/gift",
  DOWNSELL: "/doto1",
  PRIVACY: "/privacy",
  TERMS: "/terms",
  VERIFY: "/verify",
  MEMBERSHIP: "/fast-start",
  BLUEPRINT: "/blueprint",
  NOT_FIT: "/not-fit",
  HOME: "/home",
  QUALIFY: "/qualify",
  INTERVIEW: "/interview",
  MUST_WATCH: "/must-watch",
  CONFIRM_CALL_DONE: "/confirm-call-done",
  WAITLIST: "/wait",
  DISCOVERY_BOOKED: "/discovery-booked",
  SEE_IF_YOU_QUALIFY: "/see-if-you-qualify",
  OTOSU: "/otosu",
  DM_ME: "/dm-me",
  PROFIT_CALCULATOR: "/profit-calculator",
};

export const ACTIVE_VIDEO_INDEX = [0, 1, 2, 3, 4, 5, 6]

export const kThreshold = {
  unlockNextDay: {
    percentWatched: 0.5,
    seekDuration: 0.9,
  },
  qualifyButton: {
    percentWatched: 0.6,
    seekDuration: 0.95,
  },
  updateProgress: {
    percentWatched: 0.1,
    progress: 0.8,
  },
};

export enum LOCAL_STORAGE_KEY {
  SALE_USER_DATA = "SALE_USER_DATA",
  RESULT_PAGE_DATA = "RESULT_PAGE_DATA",
  IS_FILL_QUIZ = "quiz",
  DISPLAY_CONTENT = "display",
  MAGIC_PRICE = "magic",
  BOOK_CALL_POPUP = "book-call-popup",
  ACTIVE_VIDEO_KEY = "activeVideoIndex",
  IS_QUALIFY_BUTTON = "isQualifyButton",
}

export enum COOKIE_KEY {
  IS_FINISH_QUIZ = "_vrfq",
  IS_DELAYED_SALES = "_akljc",
  START_TIME = "_stabc",
  SALES_EXPIRE = "_seefg",
  TOKEN = "token",
  USER_ID = "userId",
  UNLOCK_VIDEO = "unlockvideo",
  CHECKOUT_TIMER = "_coti",
  CHECKOUT_EXPIRE = "_coefg",
  OTO1_LOGIN = "_o1l",
}

export const PAYMENT_PROCESSORS = {
  STRIPE: 'STRIPE',
  NMI: 'NMI',
};

export const COUNTRY_PHONE_CODE = {
  "af": 93,
  "al": 355,
  "dz": 213,
  "as": 1,
  "ad": 376,
  "ao": 244,
  "ag": 1,
  "ar": 54,
  "am": 374,
  "aw": 297,
  "au": 61,
  "at": 43,
  "az": 994,
  "bs": 1,
  "bh": 973,
  "bd": 880,
  "bb": 1,
  "by": 375,
  "be": 32,
  "bz": 501,
  "bj": 229,
  "bt": 975,
  "bo": 591,
  "ba": 387,
  "bw": 267,
  "br": 55,
  "bn": 673,
  "bg": 359,
  "bf": 226,
  "bi": 257,
  "kh": 855,
  "cm": 237,
  "ca": 1,
  "cv": 238,
  "cf": 236,
  "td": 235,
  "cl": 56,
  "cn": 86,
  "co": 57,
  "km": 269,
  "cg": 242,
  "cd": 243,
  "cr": 506,
  "hr": 385,
  "cu": 53,
  "cy": 357,
  "cz": 420,
  "dk": 45,
  "dj": 253,
  "dm": 1,
  "do": 1,
  "ec": 593,
  "eg": 20,
  "sv": 503,
  "gq": 240,
  "er": 291,
  "ee": 372,
  "sz": 268,
  "et": 251,
  "fj": 679,
  "fi": 358,
  "fr": 33,
  "ga": 241,
  "gm": 220,
  "ge": 995,
  "de": 49,
  "gh": 233,
  "gr": 30,
  "gt": 502,
  "gn": 224,
  "gw": 245,
  "gy": 592,
  "ht": 509,
  "hn": 504,
  "hk": 852,
  "hu": 36,
  "is": 354,
  "in": 91,
  "id": 62,
  "ir": 98,
  "iq": 964,
  "ie": 353,
  "il": 972,
  "it": 39,
  "jm": 1,
  "jp": 81,
  "jo": 962,
  "kz": 7,
  "ke": 254,
  "ki": 686,
  "kp": 850,
  "kr": 82,
  "kw": 965,
  "kg": 996,
  "la": 856,
  "lv": 371,
  "lb": 961,
  "ls": 266,
  "lr": 231,
  "ly": 218,
  "li": 423,
  "lt": 370,
  "lu": 352,
  "mo": 853,
  "mk": 389,
  "mg": 261,
  "mw": 265,
  "my": 60,
  "mv": 960,
  "ml": 223,
  "mt": 356,
  "mh": 692,
  "mq": 596,
  "mr": 222,
  "mu": 230,
  "yt": 262,
  "mx": 52,
  "fm": 691,
  "md": 373,
  "mc": 377,
  "mn": 976,
  "me": 382,
  "ma": 212,
  "mz": 258,
  "mm": 95,
  "na": 264,
  "nr": 674,
  "np": 977,
  "nl": 31,
  "nz": 64,
  "ni": 505,
  "ne": 227,
  "ng": 234,
  "nu": 683,
  "nf": 672,
  "mp": 1,
  "no": 47,
  "om": 968,
  "pk": 92,
  "pw": 680,
  "pa": 507,
  "pg": 675,
  "py": 595,
  "pe": 51,
  "ph": 63,
  "pl": 48,
  "pt": 351,
  "pr": 1,
  "qa": 974,
  "re": 262,
  "ro": 40,
  "ru": 7,
  "rw": 250,
  "ws": 685,
  "sm": 378,
  "st": 239,
  "sa": 966,
  "sn": 221,
  "rs": 381,
  "sc": 248,
  "sl": 232,
  "sg": 65,
  "sx": 1,
  "sk": 421,
  "si": 386,
  "sb": 677,
  "so": 252,
  "za": 27,
  "es": 34,
  "lk": 94,
  "sd": 249,
  "sr": 597,
  "se": 46,
  "ch": 41,
  "sy": 963,
  "tw": 886,
  "tj": 992,
  "tz": 255,
  "th": 66,
  "tl": 670,
  "tg": 228,
  "to": 676,
  "tt": 1,
  "tn": 216,
  "tr": 90,
  "tm": 993,
  "tv": 688,
  "ug": 256,
  "ua": 380,
  "ae": 971,
  "gb": 44,
  "us": 1,
  "uy": 598,
  "uz": 998,
  "vu": 678,
  "va": 39,
  "ve": 58,
  "vn": 84,
  "wf": 681,
  "eh": 212,
  "ye": 967,
  "zm": 260,
  "zw": 263
}
